<template>
  <div class="content">
    <div class="cms-website">
      <h4 class="px-4" v-show="!loaded">Loading CMS...</h4>
      <iframe id="iframeContent"
              title="CMS"
              v-show="loaded"
              v-if="iframeUrl"
              ref="iframeContent"
              @load="iframeStyles"
              width="100%"
              height="800px"
              :src="iframeUrl"></iframe>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      website: null,
      loaded: false,
      selectedPage: null,
      oldUrl: null
    }
  },
  props: {
    websiteId: String,
    selectedPageId: String
  },
  async created() {
    this.loadWebsite()
  },
  watch: {
    selectedPageId: function(new_val, old_val) {
      this.loadWebsite();
    }
  },
  computed: {
    iframeUrl() {
      if (this.website && this.selectedPage) {
        let url = `/editwebsite.php?token=99a9b929-b122-44ba-8763-d4c2d5982c3a&website_name=${this.website.name}&type=${this.selectedPage.type}&name=${this.selectedPage.name}`;
        if (url !== this.oldUrl) {
          this.loaded = false;
        }
        this.oldUrl = url;
        return url;
      }
      return false;
    }
  },
  methods: {

    async loadWebsite() {
      this.website = (await this.axios.get(`/api/websites/${this.websiteId}`)).data
      this.selectedPage = (await this.axios.get(`/api/websites/${this.websiteId}/pages/${this.selectedPageId}`)).data
    },

    iframeStyles() {
      try {
        this.loaded = false;
        if (this.website) {
          this.frame = this.$refs.iframeContent;

          let styles = `
            .login-footer {display: none;}
            .menu-wrapper {display: none;}
            .page-header {display: none;}
            .notices-wrapper {display: none;}
            .page-wrapper {width: 100%;}
            #back {display: none;}
            #delete {display: none;}
            div[data-index="websites"] {display: none;}
            div[data-index="custom_design_update"] {display: none;}
            div[data-index="custom_design_update"] {display: none;}
            div[data-index="weltpixel_rich_snippets"] {display: none;}
            div[data-index="weltpixel_options"] {display: none;}
            div[data-index="title"] {display: none;}
            div[data-index="identifier"] {display: none;}
            div[data-index="storeviews"] {display: none;}
            div[data-index="is_active"] {display: none;}
            span[data-bind="i18n: notice"] {display: none;}
            .page-footer {display: none; }
            .page-layout-admin-login {display: none; }
            .menu-wrapper._fixed~.page-wrapper {margin: 0;}
            ul[data-ui-id="save-button-dropdown-menu"] {display: none; }
            button[data-ui-id="save-button-dropdown"] {display: none; }
            #save-button { background-color: #0081C9; border: 0; margin: 0; text-shadow: none; padding: 8px; border-radius: 1px; }
            .page-main-actions { background: transparent; border: 0; }
            div[data-index="page_id"] { display: none; }
            #system_messages { display: none; }
            .page-main-actions:not(._hidden), .page-actions._fixed { background: #fff !important; border: 0 !important;}
            body { background-color: #fff; font-family: Poppins; }
          `;

          var css = document.createElement('style');
          css.type = 'text/css';
          css.appendChild(document.createTextNode(styles));

          // I know, everything is wrong with this function :) but I have to do this to hide categories.
          let scriptFunction = `
          setInterval(() => {
            try {
              let elements = jQuery('li.admin__action-multiselect-menu-inner-item._root')
              for (var i = 0; i < elements.length; i++) {
                var item = elements[i]
                if (item.outerText.indexOf("${this.website.name}") === -1) {
                  item.hide()
                }
              }
            } catch(e) { console.log(e) }
          }, 2000)
          `
          let script = document.createElement('script');
          script.appendChild(document.createTextNode(scriptFunction));

          this.frame.contentDocument.head.appendChild(css);
          this.frame.contentDocument.head.appendChild(script);

          this.loaded = true;
        }
      } catch(e) {
        console.log(e);
      }
    }

  }
}

</script>

<style scoped>

.content {
  min-width: 1000px;
}

</style>

<style>
  iframe {
    border: 0;
  }
</style>

